import React, { Fragment } from 'react'
import Select from 'react-select'
import {
  Col,
  FormInput,
  FormInputCheckbox,
  FormInputText,
  Row
} from 'camino-react'

const TicketFormGuestUserFields = ({
  primaryContactName,
  setFieldValue,
  primaryContactEmail,
  regionMetadata,
  chosenLocation,
  locations,
  clientName
}) => {
  const setRegionValues = (name, value) => {
    const newFields = Object.assign({}, regionMetadata, { [name]: value })

    setFieldValue('regionMetadata', newFields)
  }

  return (
    <Fragment>
      <Row classExtra='row--bottom-spaced'>
        <Col width={12}>
          <FormInput label="Name">
            <FormInputText value={primaryContactName} onValue={value => setFieldValue('primary_contact_name', value)} />
          </FormInput>
        </Col>

        <Col width={12}>
          <FormInput label="Company Name">
            <FormInputText value={clientName} onValue={value => setFieldValue('client_name', value)} />
          </FormInput>
        </Col>
      </Row>

      <Row classExtra='row--bottom-spaced'>
        <Col width={12}>
          <FormInput label="Contact Email">
            <FormInputText value={primaryContactEmail} onValue={value => setFieldValue('primary_contact_email', value)} />
          </FormInput>
        </Col>

        <Col width={12}>
          <FormInput label="Location">
            <Select
              value={_.find(locations, ['label', chosenLocation])}
              options={_.sortBy(locations, 'label')}
              onChange={selectedOption => {
                setFieldValue('regionId', parseInt(_.split(selectedOption.value, '_').pop()))
                setFieldValue('chosenLocation', selectedOption.label)
              }}
            />
          </FormInput>
        </Col>
      </Row>

      <Row classExtra='row--bottom-spaced'>
        <Col>
          <FormInput label="Auth PIN: If you do not have an Auth PIN, this field is optional.">
            <FormInputText value={regionMetadata.auth_pin} onValue={value => setRegionValues('auth_pin', value)} />
          </FormInput>
        </Col>
      </Row>

      <Row classExtra='row--bottom-spaced'>
        <Col>
          Please note that all Personal Data you submit to Calligo will be held and processed in accordance with our Privacy Notice, which is available
          {' '}
          <a href="https://calligo.cloud/privacy-policy/">here</a>
        </Col>
      </Row>
    </Fragment>
  )
}

export default TicketFormGuestUserFields
